// extracted by mini-css-extract-plugin
export default {"form":"CancelarServico_form__uo9gr","areaBtn":"CancelarServico_areaBtn__lyLBD","btn":"CancelarServico_btn__QBoGI","btn2":"CancelarServico_btn2__ZBo3p"};